
/****************ELEMENTS*****************/
//this obj define, the actions realeted to each  
//th>table header and td

const timeDate = require ('../../../../../js-handler/time-date')

export const tableDetail = {
    entity: 'purchase',//name table on the db
    dest: 'purchase',//name of the entity on the system

    //action for body 
    //left click, directly to the fullcont 
    tdDataDetail:`data-detail='{ "click": [ {"dest":"ripple" },
                                            {"dest":"purchase", "elem":"fullcont", "id":"purchase-fullcont", "act":"selectOne", "entity":"purchase", "dbid": "#dbid"}  ],
                                
                                 "clickRight": [{"dest":"purchase", "elem":"dt", "act":"trMenu", "id":"trMenu",  "entity":"purchase", "dbid": "#dbid" } ]  }'`,
    // andry 28/12/2023
    filter: {
        mainFilterFields : ["purchase.code","provider.name","purchase.reference_number","item.name","item.brand"],
        mainFilterValues : ["", ""],         
        andFilterFields  : [""],
        andFilterValues  : [""],  
    }

}

/****************ELEMENTS*****************/

//each element could organize their data diferent
export function organizeRow(data){ 

    var newData = []
    
    if(data.length === 0){
        newData.push({   id: 'nothing', colum: [{ label:'No Results', span: ''},
                                                { label:'', span: ''},
                                                { label:'', span: ''},
                                                { label:'', span: ''},
                                                { label:'', span: ''}, ] })
        return newData
    }

    data.forEach((elem)=>{
        let text;
        let subTextStatus;
        let textBill;
        let subTextBill;
        let paymentColor;
        let statusStyle;
        let billColor;
        let statusStyleBill;
        let subTextDueDate;
        
        const differenceInDays = timeDate.compareDates(elem.purchaseDueDate)

        if (differenceInDays > 0) {
            subTextDueDate = differenceInDays+' '+'Days Left'
        }else if(isNaN(differenceInDays)){
            subTextDueDate = 'NA'
        }else{
            subTextDueDate = Math.abs(differenceInDays)+' '+'Days Over Due'
        }

        switch (elem.payment_status) {
            case 'paid':
              text = 'Paid';
              subTextStatus = '';
              paymentColor  = 'tdWithIcon td-green-icon';
              statusStyle   = './css/svg.svg#cash';
              break;

            case 'unpaid':
                if (elem.shipping === 'ordered') {                   
                  text = 'Unpaid';
                  subTextStatus = 'Payment needed';
                  paymentColor  = 'tdWithIcon td-orange-icon';
                  statusStyle   = './css/svg.svg#cash';
                }else{
                    text          = '--';
                    subTextStatus = 'No Payment needed';
                    paymentColor  = 'tdWithIcon td-gray-icon';
                    statusStyle   = './css/svg.svg#cash';
                }
              break;

            case 'partially_paid':
              text          = 'Partially Paid';
              subTextStatus = 'Payment needed';
              paymentColor  = 'tdWithIcon td-orange-icon';
              statusStyle   = './css/svg.svg#cash';
              break;

            case 'close':
              text          = 'Close';
              subTextStatus = 'be closed';
              paymentColor  = 'tdWithIcon td-lg-icon';
              statusStyle   = './css/svg.svg#cash';
              break;

            case 'overdue':
              text          = 'overdue';
              subTextStatus = "Payment needed";
              paymentColor  = 'tdWithIcon td-red-icon';
              statusStyle   = './css/svg.svg#cash';
              break;

            case 'credited':
                text          = 'Credited';
                subTextStatus = 'Outstanding credit';
                paymentColor  = 'tdWithIcon td-orange-icon';
                statusStyle   = './css/svg.svg#cash';
                break;

            case '':
              text          = '';
              subTextStatus = '';
              paymentColor  = 'tdWithIcon td-lg-icon';
              statusStyle   = './css/svg.svg#cash';
              break;

            default:
              break;
        }

        switch (elem.shipping){

            case 'ordered':
                textBill        = 'Ordered';
                subTextBill     = 'Orde placed';
                billColor       = 'tdWithIcon td-orange-icon';
                statusStyleBill = './css/svg.svg#warning';
                break;

            case 'shipped':
                textBill        = 'Shipped';
                subTextBill     = 'Comming';
                billColor       = 'tdWithIcon td-green-icon';
                statusStyleBill = './css/svg.svg#truck';
                break;

            case 'delivered':
                textBill        = "Delivered";
                subTextBill     = 'On Site';
                billColor       = 'tdWithIcon td-gray-icon';
                statusStyleBill = './css/svg.svg#check-round';
                break;

            default:
                textBill    = '';
                subTextBill = '';
                billColor   = '';
                break;
        }
       
        newData.push(
                {   id: elem.id,   colum: [ { label: elem.providerName, span:elem.purchaseCodeREF_td,style:{ 
                                                tdClass:'tdWithAvatar',  
                                                tdClass:'tdWithAvatar',  
                                                avatar:elem.providerAvatar,
                                                avatarColor: elem.providerAvatarColor, 
                                                avatarColorLetter: elem.providerAvatarColorLetter, 
                                                avatarLetter: elem.providerAvatarLetter  
                                            } },

                                            { label: elem.due_amount, span:elem.general_total_price_dt },

                                            { label: timeDate.friendlyDate(elem.purchaseDate), span:subTextDueDate },

                                            { label: textBill, span:subTextBill,style:{ 
                                                tdClass:billColor,  
                                                svg:statusStyleBill 
                                                
                                            }},
                                            
                                            { label: text, span:subTextStatus, style:{
                                                tdClass:paymentColor,
                                                svg:statusStyle
                                            } },
                                            
                                        ]    
                }
        )/*push*/
    })/*forEach*/

    return newData
}

export function organizeRowEntityChange(data){ 
    let newData = "";
    let avatar  = "";
    let changes_inputs;
    let changes_mt;

    data.forEach((elem)=>{

        if (elem.avatar == "") {
            avatar = "css/img/pic/person.svg";
        }else{
            avatar = elem.avatar;
        }

        newData +=`<cont> 
                        <user>
                            <photo class="photo" 
                            style="background-image: url('${avatar}')"></photo>
                            <title>${elem.user_name.trim()}</title>
                            <time>${timeDate.friendlyDate(elem.date_change) + ' | ' + timeDate.friendlyTime(elem.date_change.substring(10))}</time>
                        </user>

                        <entry>
                            <div class="row">
                                <div class="c33">Data</div><!-- c16 -->
                                <div class="c33">From</div><!-- c16 -->
                                <div class="c33">To</div><!-- c16 -->
                            </div><!-- row --> 
        
                    `;

        changes_inputs = JSON.parse(elem.changes).input;

        changes_inputs.forEach(input => {
            newData +=`
                            <div class="row">
                                <div class="c33">${input.elemId}</div><!-- c16 -->
                                <div class="c33">${input.from}</div><!-- c16 -->
                                <div class="c33">${input.to}</div><!-- c16 -->
                            </div><!-- row --> 
            `;
        });

        // console.log('elem.changes', elem.changes);

        changes_mt = JSON.parse(elem.changes).mt;
        if (changes_mt.length > 0) {
            changes_mt.forEach(mt => {
                let headerColumns = [];
                let columnClasses = [];

                // Define columns based on tableName
                switch (mt.id) {
                    case 'purchase_form_purchase_vs_item':
                        headerColumns = ['Status', 'Items', 'Units', 'Qty', 'Unit Price', 'Selling Price', 'Total'];
                        columnClasses = ['c14', 'c14', 'c14', 'c14', 'c14', 'c14', 'c14'];
                        break;
                    case 'purchase_form_purchase_vs_expenses':
                        // Define columns for purchase_vs_expenses
                        headerColumns = ['Status', 'Provider', 'Expense Account', 'Date', 'Amount'];
                        columnClasses = ['c16', 'c16', 'c16', 'c16', 'c16'];
                        break;
                    case 'purchase_form_purchase_vs_lost':
                        // Define columns for purchase_vs_lost
                        headerColumns = ['Status', 'Items', 'Return', 'Lost Qty', 'Price', 'Date'];
                        columnClasses = ['c16', 'c16', 'c16', 'c16', 'c16','c16'];
                        break;
                    default:
                        throw new Error('Unknown multitable type: ' + mt.id + '. Please define a case for this id.');
                }

            newData +=`     </entry>
                        <entry>
                            <div class="row mt-8">`;
                headerColumns.forEach((header, index) => {
                    newData += `<div class="${columnClasses[index]}">${header}</div>`;
                });
                newData += `</div><!-- row --> `;

                // Handle rows based on tableName
                switch (mt.id) {
                    case 'purchase_form_purchase_vs_item':
                        mt.from.forEach(function(mt_from, index) {
                            newData += `
                            <div class="row">
                                <div class="${columnClasses[0]}">From</div>
                                <div class="${columnClasses[1]}">${mt_from.id || ''}</div>
                                <div class="${columnClasses[2]}">${mt_from.type_selling ? mt_from.type_selling[0] : ''}</div>
                                <div class="${columnClasses[3]}">${mt_from.qty || ''}</div>
                                <div class="${columnClasses[4]}">${mt_from.unit_price ? '$' + mt_from.unit_price : ''}</div>
                                <div class="${columnClasses[5]}">${mt_from.selling_price ? '$' + mt_from.selling_price : ''}</div>
                                <div class="${columnClasses[6]}">${mt_from.total_price ? '$' + mt_from.total_price : ''}</div>
                            </div><!-- row -->`;
                    
                            if (mt.to && mt.to[index]) {
                                newData += `
                                <div class="row">
                                    <div class="${columnClasses[0]}">To</div>
                                    <div class="${columnClasses[1]}">${mt.to[index].id || ''}</div>
                                    <div class="${columnClasses[2]}">${mt.to[index].type_selling ? mt.to[index].type_selling[0] : ''}</div>
                                    <div class="${columnClasses[3]}">${mt.to[index].qty || ''}</div>
                                    <div class="${columnClasses[4]}">${mt.to[index].unit_price ? '$' + mt.to[index].unit_price : ''}</div>
                                    <div class="${columnClasses[5]}">${mt.to[index].selling_price ? '$' + mt.to[index].selling_price : ''}</div>
                                    <div class="${columnClasses[6]}">${mt.to[index].total_price ? '$' + mt.to[index].total_price : ''}</div>
                                </div><!-- row -->`;
                            }
                        });
                        break;
                    case 'purchase_form_purchase_vs_expenses':
                        // Adjust the fields and structure as needed for purchase_form_purchase_vs_expenses
                        const expensesFrom = Array.isArray(mt.from) ? mt.from : [];
                        const expensesTo   = Array.isArray(mt.to) ? mt.to : [];
                        const expensesRows = Math.max(expensesFrom.length, expensesTo.length);

                        for (let index = 0; index < expensesRows; index++) {
                            const mtFrom = expensesFrom[index];
                            const mtTo   = expensesTo[index];

                            if (mtFrom) {
                                newData += purchaseVsExpensesChangeRow('From', mtFrom, columnClasses);
                            }

                            if (mtTo) {
                                newData += purchaseVsExpensesChangeRow('To', mtTo, columnClasses);
                            }
                        }
                        break;
                    case 'purchase_form_purchase_vs_lost':
                        // Adjust the fields and structure as needed for purchase_form_purchase_vs_lost 
                        const lostFrom = Array.isArray(mt.from) ? mt.from : [];
                        const lostTo   = Array.isArray(mt.to) ? mt.to : [];
                        const lostRows = Math.max(lostFrom.length, lostTo.length);

                        for (let index = 0; index < lostRows; index++) {
                            const mtFrom = lostFrom[index];
                            const mtTo   = lostTo[index];

                            if (mtFrom) {
                                newData += purchaseVsLostChangeRow('From', mtFrom, columnClasses);
                            }

                            if (mtTo) {
                                newData += purchaseVsLostChangeRow('To', mtTo, columnClasses);
                            }
                        }
                        break;
                }
        });
        }
        

        newData +=`     </entry>
                   <cont>`;



    })/*forEach*/

    return newData
}/*organizeRowEntityChange*/

function purchaseVsLostChangeRow(status, row, columnClasses) {
    const isReturn = row.return_item === true || row.return_item === 'true' || row.return_item === '1';

    return `
                            <div class="row">
                                <div class="${columnClasses[0]}">${status}</div>
                                <div class="${columnClasses[1]}">${row.purchase_vs_itemId || ''}</div>
                                <div class="${columnClasses[2]}">${isReturn ? 'Yes' : 'No'}</div>
                                <div class="${columnClasses[3]}">${row.lost_qty || ''}</div>
                                <div class="${columnClasses[4]}">${row.lost_price ? '$' + row.lost_price : ''}</div>
                                <div class="${columnClasses[5]}">${row.date || ''}</div>
                            </div><!-- row -->`;
}

function purchaseVsExpensesChangeRow(status, row, columnClasses) {
    return `
                            <div class="row">
                                <div class="${columnClasses[0]}">${status}</div>
                                <div class="${columnClasses[1]}">${row.provider_id || ''}</div>
                                <div class="${columnClasses[2]}">${row.expenses_account_id || ''}</div>
                                <div class="${columnClasses[3]}">${row.date || ''}</div>
                                <div class="${columnClasses[4]}">${row.amount ? '$' + row.amount : ''}</div>
                            </div><!-- row -->`;
}
